module.exports = __webpack_public_path__ + "img/hr-rock-small-06.7d8f8f40.png";